import PageSizeSelector from './PageSizeSelector'

export default PageSizeSelector
